import {resolveBackground} from '#core/utils/color-utils.js';

import {registerTileSchema} from '#core/application/schema-registry.js';

import MINI_SCOREBOARD from './mini-scoreboard.palette-schema.yaml';

registerTileSchema(MINI_SCOREBOARD);

export function generateMiniScoreboard(TILE) {
    const {FONT} = TILE;

    return {
        gameActionsIndication: {
            football: {
                redCard: {
                    visible: true,
                    animated: true,
                },
                score: {
                    animated: true,
                },
            },
        },
        scoresTextMain: {
            fontSize: FONT.SIZE_MEDIUM,
            fontWeight: FONT.WEIGHT_BOLD,
            fontFamily: FONT.FAMILY_SECOND || FONT.FAMILY,
            padding: '2px 0',
            ...TILE.MINI_SCOREBOARD_SCORE_COUNT_TEXT,
        },
        scoresTextSecondary: {
            fontSize: FONT.SIZE_MEDIUM,
            fontFamily: FONT.FAMILY_SECOND || FONT.FAMILY,
            fontWeight: FONT.WEIGHT_SEMI_BOLD,
            ...TILE.MINI_SCOREBOARD_SCORES_TEXT,
        },
        scoresColumn: {
            fontSize: FONT.SIZE_MEDIUM,
            fontWeight: FONT.WEIGHT_BOLD,
            ...TILE.MINI_SCOREBOARD_SCORE_COUNT_TEXT,
        },
        segmentIndicators: {
            top: '-16px',
            text: {
                fontFamily: FONT.FAMILY_SECOND || FONT.FAMILY,
                fontSize: 12,
                ...TILE.MINI_SCOREBOARD_SEGMENT_INDICATOR_TEXT,
            },
        },
        serverIndicator: {
            color: TILE.MINI_SCOREBOARD_SERVER_INDICATOR,
            width: '4px',
            _mobile_width: '6px',
        },
        scoreColumn: {
            margin: '0px 0px 0px 8px',
            minWidth: '8px',
        },
        scoreCount: {
            goalAnimationDuration: 2000,
            animation: {
                animationDuration: '.6s',
            },
            style: {
                goalContainer: {
                    ...resolveBackground(TILE.MINI_SCOREBOARD_GOAL_BG),
                    fontWeight: FONT.WEIGHT_BOLD,
                    fontSize: FONT.SIZE_MEDIUM,
                    transition: '.4s',
                    padding: '1.3px 9px',
                    minWidth: 'initial',
                    width: 'initial',
                    ...TILE.MINI_SCOREBOARD_GOAL_TEXT,
                },
                scoreText: {
                    fontSize: FONT.SIZE_MEDIUM,
                    fontWeight: FONT.WEIGHT_BOLD,
                    ...TILE.MINI_SCOREBOARD_SCORE_COUNT_TEXT,
                },
            },
        },
        redCard: {
            animation: {
                animationDuration: '.6s',
            },
            container: {
                createStackingContext: true,
            },
            style: {
                bannerContainer: {
                    ...resolveBackground(TILE.MINI_SCOREBOARD_RED_CARD_BG),
                    top: -1, // to hide red card under this container
                    fontSize: FONT.SIZE_MEDIUM,
                    fontWeight: FONT.WEIGHT_BOLD,
                    ...TILE.MINI_SCOREBOARD_RED_CARD_TEXT,
                },
                card: {
                    ...resolveBackground(TILE.MINI_SCOREBOARD_RED_CARD_BG),
                },
                text: {
                    fontSize: '9px',
                    fontWeight: FONT.WEIGHT_BOLD,
                    ...TILE.MINI_SCOREBOARD_RED_CARDS_AMOUNT_TEXT,
                },
            },
        },
    };
}
